/**
 * 라이브 게임사 → 그 게임사의 로비 게임(DB game.type = 'lobby').
 *   벤더 목록에서 라이브를 누르면 게임 목록 대신 이 로비로 바로 들어간다(그랜드라인과 같은 방식).
 *   vendor·id 는 gold8 DB game 의 vendor·id 그대로 — 로비 게임은 메뉴에 묶여 있지 않아 게임 목록 API 로는 못 찾는다.
 *   게임사 이름은 사이트마다 달라(그랜드라인 가타카나 / 사이트 6 은 MG·PP·EVO 약자) 정규화해서 찾는다.
 */
const LIVE_LOBBIES = [
  [['プラグマティック', 'PP', 'PRAGMATIC', 'PRAGMATICPLAY'], { vendor: 'PragmaticPlay Live', id: '101' }],
  [['プレイテック', 'PT', 'PLAYTECH'], { vendor: 'Playtech', id: 'ubal' }],
  [['エボリューション', 'EVO', 'EVOLUTION'], { vendor: 'evolution', id: 'evolution_all_games' }],
  [['マイクロゲーミング', 'MG', 'MICROGAMING'], { vendor: 'MicroGaming', id: 'MGL_GRAND_LobbyAll' }],
  [['プレイエース（旧 アジアゲーミング）', 'PLAYACE'], { vendor: 'Asia Gaming', id: '0' }],
]

/** 게임사 이름 비교용 — 대소문자·공백·구분 기호를 없앤다. */
export const normVendor = (v) => String(v || '').toUpperCase().replace(/[\s_\-·・]/g, '')

/** 게임사 이름으로 로비 게임({ vendor, id })을 찾는다. 없으면 null. */
export const liveLobbyOf = (name) => {
  const key = normVendor(name)
  return LIVE_LOBBIES.find(([names]) => names.some((n) => normVendor(n) === key))?.[1] || null
}
